import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class="container">
  <DiscourseBanner />
  {{#if @model.category}}
    <CategoryReadOnlyBanner
      @category={{@model.category}}
      @readOnly={{@createTopicDisabled}}
    />
  {{/if}}
</div>

<span>
  <PluginOutlet
    @name="discovery-list-controls-above"
    @connectorTagName="div"
    @outletArgs={{hash category=@model.category tag=@model.tag}}
  />
</span>

<div class="list-controls">
  <PluginOutlet
    @name="discovery-navigation-bar-above"
    @connectorTagName="div"
    @outletArgs={{hash category=@model.category tag=@model.tag}}
  />
  <div class="container">
    {{yield to="navigation"}}
  </div>
</div>

<PluginOutlet
  @name="discovery-above"
  @connectorTagName="div"
  @outletArgs={{hash category=@model.category tag=@model.tag}}
/>

<div class="container list-container">
  <div class="row">
    <div class="full-width">
      <div id="header-list-area">
        {{yield to="header"}}
        <PluginOutlet
          @name="header-list-container-bottom"
          @outletArgs={{hash category=@model.category tag=@model.tag}}
        />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="full-width">
      <PluginOutlet
        @name="before-list-area"
        @outletArgs={{hash category=@model.category tag=@model.tag}}
      />
      <div id="list-area">
        <PluginOutlet
          @name="discovery-list-area"
          @outletArgs={{hash
            category=@model.category
            tag=@model.tag
            model=@model
          }}
          @defaultGlimmer={{true}}
        >
          <PluginOutlet
            @name="discovery-list-container-top"
            @connectorTagName="span"
            @outletArgs={{hash category=@model.category tag=@model.tag}}
          />
          {{yield to="list"}}
        </PluginOutlet>
      </div>
    </div>
  </div>
</div>

<span>
  <PluginOutlet
    @name="discovery-below"
    @connectorTagName="div"
    @outletArgs={{hash category=@model.category tag=@model.tag}}
  />
</span>
*/
{
  "id": "1ZDdUQzU",
  "block": "[[[10,0],[14,0,\"container\"],[12],[1,\"\\n  \"],[8,[39,0],null,null,null],[1,\"\\n\"],[41,[30,1,[\"category\"]],[[[1,\"    \"],[8,[39,2],null,[[\"@category\",\"@readOnly\"],[[30,1,[\"category\"]],[30,2]]],null],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\\n\"],[10,1],[12],[1,\"\\n  \"],[8,[39,3],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"discovery-list-controls-above\",\"div\",[28,[37,4],null,[[\"category\",\"tag\"],[[30,1,[\"category\"]],[30,1,[\"tag\"]]]]]]],null],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"list-controls\"],[12],[1,\"\\n  \"],[8,[39,3],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"discovery-navigation-bar-above\",\"div\",[28,[37,4],null,[[\"category\",\"tag\"],[[30,1,[\"category\"]],[30,1,[\"tag\"]]]]]]],null],[1,\"\\n  \"],[10,0],[14,0,\"container\"],[12],[1,\"\\n    \"],[18,3,null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[8,[39,3],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"discovery-above\",\"div\",[28,[37,4],null,[[\"category\",\"tag\"],[[30,1,[\"category\"]],[30,1,[\"tag\"]]]]]]],null],[1,\"\\n\\n\"],[10,0],[14,0,\"container list-container\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"row\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"full-width\"],[12],[1,\"\\n      \"],[10,0],[14,1,\"header-list-area\"],[12],[1,\"\\n        \"],[18,4,null],[1,\"\\n        \"],[8,[39,3],null,[[\"@name\",\"@outletArgs\"],[\"header-list-container-bottom\",[28,[37,4],null,[[\"category\",\"tag\"],[[30,1,[\"category\"]],[30,1,[\"tag\"]]]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"row\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"full-width\"],[12],[1,\"\\n      \"],[8,[39,3],null,[[\"@name\",\"@outletArgs\"],[\"before-list-area\",[28,[37,4],null,[[\"category\",\"tag\"],[[30,1,[\"category\"]],[30,1,[\"tag\"]]]]]]],null],[1,\"\\n      \"],[10,0],[14,1,\"list-area\"],[12],[1,\"\\n        \"],[8,[39,3],null,[[\"@name\",\"@outletArgs\",\"@defaultGlimmer\"],[\"discovery-list-area\",[28,[37,4],null,[[\"category\",\"tag\",\"model\"],[[30,1,[\"category\"]],[30,1,[\"tag\"]],[30,1]]]],true]],[[\"default\"],[[[[1,\"\\n          \"],[8,[39,3],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"discovery-list-container-top\",\"span\",[28,[37,4],null,[[\"category\",\"tag\"],[[30,1,[\"category\"]],[30,1,[\"tag\"]]]]]]],null],[1,\"\\n          \"],[18,5,null],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,1],[12],[1,\"\\n  \"],[8,[39,3],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"discovery-below\",\"div\",[28,[37,4],null,[[\"category\",\"tag\"],[[30,1,[\"category\"]],[30,1,[\"tag\"]]]]]]],null],[1,\"\\n\"],[13]],[\"@model\",\"@createTopicDisabled\",\"&navigation\",\"&header\",\"&list\"],false,[\"discourse-banner\",\"if\",\"category-read-only-banner\",\"plugin-outlet\",\"hash\",\"yield\"]]",
  "moduleName": "discourse/components/discovery/layout.hbs",
  "isStrictMode": false
});